export default __webpack_public_path__ + "static/media/rollRight.51e38a1d.gif";